<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =

[{"num_cand":"U2FsdGVkX1+6A83LnK4UdG7oxC62yrghJadNL08k1OU=","cpf":"U2FsdGVkX19nOVTdxzNl8N2Y0kNTQxgv3JES3qPY4E4="},{"num_cand":"U2FsdGVkX1/saV/V596P7fJ2YxpJwPI5S7jrtyt4Qh4=","cpf":"U2FsdGVkX1+p38x6Y7iXXxWn3xfajyC9Trw0Gwa1lgA="},{"num_cand":"U2FsdGVkX18WnPtG1L1N/9WRXVP/Ufn8+7TseljbW2o=","cpf":"U2FsdGVkX1/IM0CdqfHjIN2a2RRcAbAZUytq0UcB5Kg="},{"num_cand":"U2FsdGVkX19yTaUWeGH5DHRU8abhrEW+dKEFZgxrcpQ=","cpf":"U2FsdGVkX1+oMSeCuHa/JaRQLTMuTjHYgLz+E9F4V18="},{"num_cand":"U2FsdGVkX1+KwndCi3JShbe4spEiE1TW2Cg7t5bwbr0=","cpf":"U2FsdGVkX1/3X/gYc7lKnwxjWWEjcYadAa5RbU972Wo="},{"num_cand":"U2FsdGVkX1+kVMxvrwPLPYpNEOTMfZlkFsZgFF8qmTY=","cpf":"U2FsdGVkX1+zPmkG5kVuMAc2xwz2RElRDf8APMigiTo="},{"num_cand":"U2FsdGVkX18hwGJibVmF3rj+91Ujy75z+I1RUShXOto=","cpf":"U2FsdGVkX1/A1a8ipHXoBq2CchlVigS8BsqxCAF0kF4="},{"num_cand":"U2FsdGVkX1+Alle0oVPPs1G6tG9YYVFvaRgFZ4oHrCQ=","cpf":"U2FsdGVkX18YXkUYMLjvRQ86DrUAlkBKj20FWtaMxgQ="},{"num_cand":"U2FsdGVkX1+vZDWdJZ8ysc9jYIXVylzP4FU7Nhm2GQE=","cpf":"U2FsdGVkX19mC0sN20aRSACPRHyqY0maw9nl/Tw3PFs="},{"num_cand":"U2FsdGVkX1/DEJCiXqjZMFtrmJzObhthU4bKStG0yJM=","cpf":"U2FsdGVkX19DV7CVR0omIWDKFpihWEsv1EnKN7G5eT8="},{"num_cand":"U2FsdGVkX1+c2BAiApD5tns79IXZBitiR5P6tCPykGY=","cpf":"U2FsdGVkX1/0XZhEESY33tMKtdP9f2wbhURfV+f9t38="},{"num_cand":"U2FsdGVkX1806aROfjDc3xOpwQ2CukFz0CrWeXFf4+c=","cpf":"U2FsdGVkX1+M0eUdKQR6FbDc7tGalL8MmWvygoe0Adg="},{"num_cand":"U2FsdGVkX1/XBPUe547Gzuv537HY9+I66Cm1FRUtXGk=","cpf":"U2FsdGVkX1/nkQIGSeugLo3WGLzLO7JyJP968EZuEyE="},{"num_cand":"U2FsdGVkX18MjXcF67kUXjqpaOqW9HUsSyTRpGqcn3U=","cpf":"U2FsdGVkX1+aMmKRi5Vxmiq4/XsXnkG1VHai36S7sJw="},{"num_cand":"U2FsdGVkX1+CPgSjb5bF5lcGo8h9CoKV1jK+AVbwohY=","cpf":"U2FsdGVkX1+NtYCxsOIFfQxqg3abURHB6k6wsYFvk0g="},{"num_cand":"U2FsdGVkX19r6KBivs0+nVig26gWAifmwJbI5CnPxas=","cpf":"U2FsdGVkX19cutody3G+ZXX2lAcwKQmA3LkwDdSttNk="},{"num_cand":"U2FsdGVkX1/TMr+doXsZ4GynWxT/ohL6zSZOhTl6IUw=","cpf":"U2FsdGVkX19JSYK49AfLyBoK+GDnl7AA2aSqfjF1uOg="},{"num_cand":"U2FsdGVkX1/Z2yWoNEaKsl7RqW3zEgxUR1rQNzaboqw=","cpf":"U2FsdGVkX1/y5l48wBMaTYq338y2RER8lDTm88Ec8Mg="},{"num_cand":"U2FsdGVkX19+AeIypNwICfUadbdQPG+Mm55Ag0va/rY=","cpf":"U2FsdGVkX1+Sdsp18zyKj/EywK3l51vQgeAKiW+ouK8="},{"num_cand":"U2FsdGVkX19ONahVBUIJchVxYrP70JGjDQ3UlngrZ0Y=","cpf":"U2FsdGVkX18kCCp2OpE4dcpGH7xdT1UJyiiLfy8bTX4="},{"num_cand":"U2FsdGVkX18pxux5mEuy7ix0uQXpzd62ve+UXEaxgw0=","cpf":"U2FsdGVkX1+HEylmQTIE0z6iStTzxw6Rx/6wg9vpnaA="},{"num_cand":"U2FsdGVkX18f6+d/jXD27Mn32l8uX8FFgnxyOyXyaes=","cpf":"U2FsdGVkX19c4cfYnZe8+NE0C9LALFLzCJLUHiFWOfs="},{"num_cand":"U2FsdGVkX19UUrY8Dy7fXpKKYtpStDDPkLZUP+fafx4=","cpf":"U2FsdGVkX1/10ZAE/ECYC/F0SItcNUDwuq3MpaQDOVg="},{"num_cand":"U2FsdGVkX18r6CVPzxg1vGFFWfynNCk7pgjBknSljdo=","cpf":"U2FsdGVkX1/LMN1GKwq9tqNRTv/89Eg2s4Sn5ktmtOo="},{"num_cand":"U2FsdGVkX1+zd3hMQbG0/jHf/wjkIA9QkBwbzKJYaQA=","cpf":"U2FsdGVkX19v++b+DsptVNbijiD5+jw7yqctHBiD900="},{"num_cand":"U2FsdGVkX19YlwdouY/FW7b2YXBT+2Qa3ataUa84bQo=","cpf":"U2FsdGVkX18lNVxmDx9VDBu5bxEDhFO/r75ZZbt50Qk="},{"num_cand":"U2FsdGVkX1+Bpo+P1MeALX9qtbFVTv+SduEtZvTANZQ=","cpf":"U2FsdGVkX19q8bN32Lxi+oDQYXOkULG6YZdo6AqdCp8="},{"num_cand":"U2FsdGVkX1+kAObNE41oil46quhuhh4KniixpYuc7/4=","cpf":"U2FsdGVkX18/DxT8SR3VHvOqCeIEKUw0viWWBdkKQg0="},{"num_cand":"U2FsdGVkX1/AazbQOA8DU3vrxUbXlMYri9cS6bR0gqo=","cpf":"U2FsdGVkX18+T1YnQnnBb1rPoSxB1kdK7ulnzVL3NaY="},{"num_cand":"U2FsdGVkX1+dWDWn3r4/YSuf+gdECaJI48MvQAYI69M=","cpf":"U2FsdGVkX1/HtGs5TjHW6yzO3988+m8D43wvElSF0Uk="},{"num_cand":"U2FsdGVkX1/EY50JhiPxzIAJE3G1oURN3EnWrBErxCw=","cpf":"U2FsdGVkX18xEkbeaZJJb7MO1dzc/0PJrG1ETDtX0JU="},{"num_cand":"U2FsdGVkX19gTXyaZEFxUfTjqBJwTD+7nehk7wBIVvU=","cpf":"U2FsdGVkX1/JPB3pZJw9JN1WNbqDJtBkKHJ+zAkWZik="},{"num_cand":"U2FsdGVkX1/w6t1eBXOI8b6BXUt7QpgPTlMn51xP/A0=","cpf":"U2FsdGVkX1/3LmWFrSwcrAiWZyULdlhUahyZsj1Uabg="},{"num_cand":"U2FsdGVkX18+hLRL8XT2Sa2p5T1aIVt/+TX/wwAR/RQ=","cpf":"U2FsdGVkX18Hkpr63PbN9qMvn6OCeJb/5Q4Fe/PHbNI="},{"num_cand":"U2FsdGVkX19mKIryAID04AkLnvYawhAgxs4v56jN2tQ=","cpf":"U2FsdGVkX1+ETXVJtyYoRrCg6zVHb4B3JochhtR7WgE="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2207/rec_pcd/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
